module.exports = __webpack_public_path__ + "img/stickers-declaration-revenus.1bab7435.jpg";